var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54297 1.375L12.1675 11.9995L22.792 1.375",
    stroke: "#D4D4D4",
    strokeWidth: 2.40509
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.6b317813c5d215c6c591d41c9d745c12.svg";